<div class="patient">
  <div class="wrapper">
    <div *ngIf="showPopUp" class="print-history-popup">
      <div class="print-history-popup-body">
        <h2 class="popup-title">
          Please select a doctor to whom the patient will be assigned
        </h2>
        <button
          (click)="showPopUp = false"
          class="print-history-popup-close"
          aria-label="close popup"
        ></button>
      </div>
    </div>
    <div
      style="top: 30%; width: 700px"
      *ngIf="xmlLoading"
      class="print-history-popup"
    >
      <div class="print-history-popup-body">
        <h2 class="popup-title">הפעולה עשויה להימשך 2-3 דקות, נא להמתין</h2>
      </div>
    </div>

    <!-- ========================== header (start) ========================== -->
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel" [ngClass]="isReports ? 'space' : ''">
        <div style="display: flex; align-items: center">
          <h1 class="t-title-main">
            {{
              AWLlist ? "TodayList" : examList || xmlList ? "Exams" : "Patients"
            }}
          </h1>
          <div
            class="l-flex l-flex-c t-field t-field-pad"
            *ngIf="AWLlist"
            style="margin-left: 2em"
          >
            <label> Status </label>

            <i class="t-sep"></i>

            <select
              class="t-field t-select"
              [(ngModel)]="AWLStatus"
              (change)="AWL(); startdate = null; enddate = null"
            >
              <option value="All">All</option>
              <option value="Waiting">Scheduled</option>
              <option value="Received">Waiting</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Waiting for Interpretation</option>
              <option value="Interpreted">Interpreted</option>
            </select>
          </div>
        </div>
        <span
          *ngIf="AWLlist && AWLStatus == 'Completed'"
          style="margin-left: 1em"
        >
          Exam Type
          <select
            class="t-field t-select"
            [(ngModel)]="AWLExam"
            (change)="AWL()"
          >
            <option value="All">All</option>
            <option *ngFor="let name of examNamesUSG" [value]="name">
              {{ name }}
            </option>
          </select>
        </span>
        <span
          *ngIf="AWLlist && AWLStatus == 'Completed'"
          style="margin-left: 1em"
          (dblclick)="startdate = null; enddate = null; AWL()"
        >
          From
          <input
            [matDatepicker]="startDatepicker"
            [(ngModel)]="startdate"
            [max]="enddate"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (click)="startDatepicker.open()"
            (ngModelChange)="AWL()"
          />
          <mat-datepicker #startDatepicker></mat-datepicker>
          Until
          <input
            [matDatepicker]="endDatepicker"
            [(ngModel)]="enddate"
            [min]="startdate"
            (click)="endDatepicker.open()"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (ngModelChange)="AWL()"
          />
          <mat-datepicker #endDatepicker></mat-datepicker>
        </span>
        <!-- <div
       
          style="
            width: 70%;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
          "
        >
          <span *ngIf="isReports && xmlList && xmlList.length > 0"
            >Gastroscopy: {{ xmlList ? filterExams(xmlList, "Gastroscopy").length : 0 }}</span
          >
          <span *ngIf="isReports && xmlList && xmlList.length > 0"
            >Colonoscopy: {{ xmlList ? filterExams(xmlList, "Colonoscopy").length : 0 }}</span
          >
          <span *ngIf="isReports && xmlList && xmlList.length > 0"
            >Sigmoidoscopy: {{ xmlList ? filterExams(xmlList, "Sigmoidoscopy").length : 0 }}</span
          >
          <span *ngIf="isReports && xmlList && xmlList.length > 0"
            >Number Of Exams: {{ xmlList ? xmlList.length : 0 }}</span
          >
          <button
            (click)="downloadXml('Clalit'); showDownLoad = false"
            class="search-btn search-btn--newPatient"
            style="width: 20%"
            *ngIf="xmlList && xmlList.length && showDownLoad"
          >
            DownLoad
          </button>
          <span
            (click)="exporXmlList()"
            class="header-menu-link icon-file"
            aria-label="Export"
            matTooltip="Export to Excel"
            *ngIf="xmlList && xmlList.length > 0"
          ></span>
        </div> -->
        <div style="display: inline-flex" *ngIf="isReports && showExcel">
          <button
            (click)="sendMacabi()"
            class="search-btn search-btn--newPatient"
            *ngIf="!sentMacabi && canSendMacabi()"
          >
            Send to Macabi
          </button>
          <span
            (click)="export()"
            class="header-menu-link icon-file"
            aria-label="Export"
            matTooltip="Export"
            *ngIf="
              examList &&
              examList.length > 0 &&
              (!macabiMissing || reportName != 'Macabifin')
            "
          ></span>
          <span
            (click)="showprintopts = true; showprint = true"
            class="header-menu-link icon-print"
            aria-label="Print"
            matTooltip="Print"
            *ngIf="reportName != 'Macabifin'"
          ></span>
        </div>
        <button
          class="search-btn search-btn--newPatient"
          *ngIf="AWLlist && !swiping"
          style="margin-left: auto; width: 8em"
          (click)="swiping = true; getcard()"
        >
          הצג כרטיס מגנטי
        </button>
        <button
          class="search-btn search-btn--newPatient"
          *ngIf="AWLlist && loginService.barcodeScan && !swiping"
          style="margin-left: auto; width: 8em"
          (click)="swiping = true; getcard()"
        >
          Scan barcode
        </button>
        <input
          *ngIf="AWLlist && swiping"
          #swipeField
          (keyup)="proccesscard($event)"
          [(ngModel)]="card"
        />
        <input
          *ngIf="AWLlist && loginService.barcodeScan && swiping"
          #swipeField
          (keyup)="barscan($event)"
          [(ngModel)]="card"
        />
        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
        <div
          *ngIf="
            (loginService.isAdmin || loginService.userType == 'secretary') &&
            (loginService.separatedClinic || loginService.SeparateZimun)
          "
          style="position: absolute; right: 6em"
        >
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label matTooltip="שם הרופא">
              <img src="../../assets/icons/drb.svg" />
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <select
                [(ngModel)]="loginService.doctor"
                (ngModelChange)="AWL()"
                class="t-select w100"
                style="text-align: center"
              >
                <option [value]="null">All</option>
                <!-- <option *ngIf="awlExam && ! examTypes.includes(awlExam)" [value]="awlExam">{{awlExam}}</option> -->
                <ng-container *ngFor="let e of getDoctors()">
                  <option [value]="e.UID">{{ e.Name }}</option>
                </ng-container>
              </select>
            </span>
          </div>
        </div>

        <!-- *ngIf="examList && examList.length && loginService.userType==='admin'" -->
        <!-- <img
          style="cursor: pointer; position: absolute; right: 3%; top: 50%; transform: translateY(-50%)"
          matTooltip="Download CSV"
          *ngIf="examList && examList.length "
          (click)="generateXlExams(examList)"
          height="31em"
          src="../../assets/icons/file.svg"
        /> -->
      </div>
    </header>
    <!-- ========================== header (end) ========================== -->

    <!-- ========================== intro (start) ========================== -->

    <main class="l-deashboard">
      @if (searchLoading) {
        <div class="list-spinner-wrap" [class.is-leaving]="searchFading">
          <img
            src="../../assets/images/Wedges.svg"
            alt="Loading..."
            class="list-spinner-img"
          />
        </div>
      } @else {
        @if (isAWL && AWLlist && AWLlist.length === 0) {
          @if (AWLStatus && AWLStatus != "All") {
            <p style="padding: 2rem; text-align: center">
              {{
                "GUI.Patients.empty.today status"
                  | translate
                    : {
                        status:
                          ("GUI.Patients.todaylist.statues." +
                            (AWLStatus == "Completed"
                              ? "Waiting for Interpretation"
                              : AWLStatus == "Waiting"
                                ? "Scheduled"
                                : AWLStatus) | translate),
                      }
              }}
            </p>
          } @else {
            <p style="padding: 2rem; text-align: center">
              {{ "GUI.Patients.empty.today" | translate }}
            </p>
          }
        }
        <div
          class="l-flex patient-item"
          *ngFor="let pat of AWLlist; index as i"
        >
          <div class="w100 patient-item-link">
            <div class="l-table h100">
              <span
                class="l-td-m patient-item-cell patient-id"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                Time:
                <strong>{{
                  AWLStatus == "Completed"
                    ? (pat.ExamDate | date: "d/M/yy, h:mm a")
                    : (pat.ExamDate | date: "shortTime")
                }}</strong>
              </span>
              <span
                class="l-td-m patient-item-cell patient-id"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                ID: <strong>{{ pat.ID }}</strong>
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                [ngClass]="pat.Reason ? 'type-v' : 'type-plus'"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{ pat.First }} {{ pat.Last }}
                <!-- <img src="../../assets/icons/patlabel.svg" style="float: inline-end;" matTooltip="Print Label" (click)="$event.stopPropagation();printLabel(pat.HMO, pat.PID)" /> -->
                <span
                  class="anatomy-show-more"
                  style="bottom: auto; right: auto"
                  *ngIf="
                    (!loginService.ishospital ||
                      loginService.ishospital == 'belinson') &&
                    !loginService.isUSG
                  "
                >
                  <!--form elemnts not working when empty so using hack-->

                  <div class="on-hoverPanel">
                    <div class="on-hoverPanel-body">
                      <div class="anatomy-item-details">
                        <div class="anatomy-items-desc">
                          <div
                            class="anatomy-items-edited scroller mCustomScrollbar _mCS_2 mCS_no_scrollbar"
                            contenteditable="true"
                          >
                            <div
                              id="mCSB_2"
                              class="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                              tabindex="0"
                              style="max-height: none"
                            >
                              <div
                                id="mCSB_2_container"
                                class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
                                style="position: relative; top: 0; left: 0"
                                dir="ltr"
                              ></div>
                              <div
                                id="mCSB_2_scrollbar_vertical"
                                class="mCSB_scrollTools mCSB_2_scrollbar mCS-light mCSB_scrollTools_vertical"
                                style="display: none"
                              >
                                <div class="mCSB_draggerContainer">
                                  <div
                                    id="mCSB_2_dragger_vertical"
                                    class="mCSB_dragger"
                                    style="
                                      position: absolute;
                                      min-height: 30px;
                                      top: 0px;
                                      display: block;
                                      height: 12px;
                                      max-height: 106.938px;
                                    "
                                  >
                                    <div
                                      class="mCSB_dragger_bar"
                                      style="line-height: 30px"
                                    ></div>
                                  </div>
                                  <div class="mCSB_draggerRail"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <textarea
                            class="anatomy-items-edit"
                            (click)="$event.stopPropagation()"
                            (change)="saveComment(pat.Reason, pat.AWLID)"
                            [(ngModel)]="pat.Reason"
                          ></textarea>
                        </div>
                      </div>

                      <!--<button class="anatomy-details-save">Save Comments</button> -->
                    </div>
                  </div>
                </span>
              </span>

              <span
                class="l-td-m patient-item-cell patient-name-last"
                *ngIf="loginService.ishospital && !loginService.AWLExamNames"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                Address: {{ pat.Address }} {{ pat.City }}
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="!loginService.ishospital"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                Phone: {{ pat.Phone ? pat.Phone : pat.Mobile }}
              </span>
              <span
                class="l-td-m patient-item-cell"
                *ngIf="
                  (!loginService.ishospital || loginService.AWLExamNames) &&
                  pat.ExamCode
                "
              >
                {{ pat.ExamCode }}
                <ng-container *ngIf="pat.HMOExamCode">
                  <br />
                  <strong>קוד טיפול:</strong> {{ pat.HMOExamCode
                  }}<span *ngIf="pat.HMOExamName">
                    - {{ pat.HMOExamName }}</span
                  >
                </ng-container>
                <ng-container
                  *ngIf="
                    !loginService.isCardio &&
                    !loginService.isUSG &&
                    loginService.premissions.Consent
                  "
                >
                  <img
                    src="../../assets/icons/login/text-file-icon.svg"
                    style="height: 1.5em; width: 1.5em"
                    matTooltip="Open Consent Form"
                    (click)="startForm(pat)"
                  />
                </ng-container>
                <ng-container
                  *ngIf="
                    loginService.isUSG &&
                    loginService.premissions?.Consent &&
                    canOpenConsent(pat.ExamCode)
                  "
                >
                  <img
                    src="../../assets/icons/login/text-file-icon.svg"
                    style="height: 1.5em; width: 1.5em; cursor: pointer; margin-right: 0.3em;"
                    matTooltip="Open Consent Form"
                    (click)="
                      $event.stopPropagation();
                      openUsgConsentFromAWL(pat)
                    "
                  />
                </ng-container>
                <ng-container *ngIf="loginService.premissions?.Questionnaires">
                  <span style="position: relative; display: inline-block">
                    <img
                      src="../../assets/icons/chat.svg"
                      style="
                        height: 1.5em;
                        width: 1.5em;
                        cursor: pointer;
                        margin-inline-start: 0.3em;
                      "
                      matTooltip="{{
                        'GUI.Tooltips.Send Questionnaire' | translate
                      }}"
                      (click)="
                        $event.stopPropagation(); openSendQuestionnaire(pat)
                      "
                    />
                    <span
                      *ngIf="patQuestionnaireAnswered[pat.AWLID]"
                      style="
                        position: absolute;
                        bottom: -0.1em;
                        right: -0.4em;
                        font-size: 0.75em;
                        color: green;
                        font-weight: bold;
                        background: white;
                        border-radius: 50%;
                        line-height: 1;
                        padding: 0 1px;
                      "
                      >✓</span
                    >
                  </span>
                </ng-container>
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="
                  (!loginService.ishospital || loginService.AWLExamNames) &&
                  !pat.ExamCode
                "
              >
                <select
                  class="t-field t-select"
                  [(ngModel)]="changedExamCode"
                  (ngModelChange)="setExamCode(pat)"
                >
                  <option *ngFor="let name of examNamesUSG" [value]="name">
                    {{ name }}
                  </option>
                </select>
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="
                  loginService.separatedClinic &&
                  (loginService.isAdmin || loginService.userType == 'secretary')
                "
              >
                {{ loginService.getDocByUID(pat.UID) }}
              </span>

              <span
                class="l-td-m patient-item-cell patient-name-first"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{ getStatus(pat.Status) }}
              </span>
            </div>
          </div>
          <a
            class="l-td-m patient-item-exit"
            routerLink="/exams"
            (click)="patservice.setPat(pat); setPatAwlid(pat)"
            [state]="{ data: pat }"
          ></a>
        </div>

        @if (patList && patList.length === 0 && !isAWL) {
          <p style="padding: 2rem; text-align: center">
            {{ "GUI.Patients.empty.patients" | translate }}
          </p>
        } @else if (patList && !isAWL) {
          <app-pagination-controls
            [total]="totalResults"
            [page]="currentPage"
            [totalPages]="totalPages"
            (prev)="previousPage()"
            (next)="nextPage()"
          ></app-pagination-controls>
          <div class="l-flex patient-item" *ngFor="let pat of patList">
            <button
              class="w100 patient-item-link"
              (click)="selectedPatient = pat"
              matTooltip="Open Patient Record"
            >
              <div class="l-table h100">
                <span class="l-td-m patient-item-cell patient-id">
                  {{ pat.IsID ? "ID" : "Passport" }}:
                  <strong>{{ pat.ID }}</strong>
                </span>

                <span class="l-td-m patient-item-cell patient-name-first">
                  {{ pat.First }}
                </span>

                <span class="l-td-m patient-item-cell patient-name-last">
                  {{ pat.Last }}
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="
                    loginService.separatedClinic &&
                    (loginService.isAdmin ||
                      loginService.userType == 'secretary')
                  "
                >
                  {{ loginService.getDocByUID(pat.UID) }}
                </span>
              </div>
            </button>
            <a
              class="l-td-m patient-item-exit"
              routerLink="/exams"
              (click)="patservice.setPat(pat)"
              [state]="{ data: pat }"
              matTooltip="Open Patient History"
            ></a>
          </div>
          @if (patList.length >= pageSize && totalPages > 1) {
            <app-pagination-controls
              [total]="totalResults"
              [page]="currentPage"
              [totalPages]="totalPages"
              (prev)="previousPage()"
              (next)="nextPage()"
            ></app-pagination-controls>
          }
        }
      }

      <div>
        <div
          *ngIf="exServ.searchReport"
          style="
            margin: 10px;
            padding: 10px;
            border-radius: 10px;
            border: 1px solid grey;
          "
        >
          <div
            class="w100"
            style="
              display: flex;
              justify-content: space-evenly;
              flex-direction: row-reverse;
            "
          >
            <span style="margin: 0 5px">
              <label style="margin: 0 5px; font-weight: 700">חיפוש לפי</label>
              <span
                style="margin: 0 5px"
                *ngIf="exServ.searchReport.type == 'Macabifin'"
                >דו"ח מכבי פיננסי
                <select
                  class="t-field t-select"
                  [(ngModel)]="macabiMissing"
                  (change)="examSearch('Macabifin', 'Macabi')"
                >
                  <option [ngValue]="false">פרטים מלאים</option>
                  <option value="codes">חסר קוד טיפול</option>
                  <option value="refnum">חסר פרטים אחרים</option>
                  <option value="notsigned">לא נחתם</option>
                </select>
              </span>
              <span
                style="margin: 0 5px"
                *ngIf="exServ.searchReport.type == 'Macabi'"
                >בדיקות שנשלחו למכבי</span
              >
              <span
                style="margin: 0 5px"
                *ngIf="exServ.searchReport.type == 'Refferelnum'"
                >מס' הפניה חסר</span
              >
              <span
                style="margin: 0 5px"
                *ngIf="exServ.searchReport.type == 'HMO'"
                >{{ getHMO(exServ.searchReport.hmo) }}</span
              >
            </span>
            <span
              style="margin: 0 5px; display: flex; flex-direction: row-reverse"
            >
              <label style="margin: 0 5px; font-weight: 700">תאריכים</label>
              <div style="display: flex; flex-direction: row">
                <span>
                  {{ exServ.searchReport.start | date: "dd/MM/yyyy" }}
                </span>
                <label>-</label>
                <span>{{ exServ.searchReport.end | date: "dd/MM/yyyy" }}</span>
              </div>
            </span>
          </div>
        </div>
        <!-- <div *ngFor="let name of examNamesUSG" style="margin: 1em 0">
          <div
            class="l-flex"
            *ngIf="filterExams(examList, name).length > 0"
            style="display: flex; justify-content: space-between"
          >
            <span style="font-size: x-large"
              ><strong>{{ name }}</strong></span
            >
            <div class="l-flex r-hmos">
              <span
                [ngClass]="
                  examList &&
                  filterExams(examList, name, 'Leumit').length >=
                    loginService.limits[getDbName(name, 'Leumit')]
                    ? 'error'
                    : ''
                "
                *ngIf="loginService.limits[getDbName(name, 'Leumit')]"
                style="font-size: x-large"
                ><strong
                  >Leumit: {{ filterExams(examList, name, "Leumit").length }}/{{
                    loginService.limits[getDbName(name, "Leumit")]
                  }}</strong
                ></span
              >
              <span
                [ngClass]="
                  examList &&
                  filterExams(examList, name, 'Macabi').length >=
                    loginService.limits[getDbName(name, 'Macabi')]
                    ? 'error'
                    : ''
                "
                *ngIf="loginService.limits[getDbName(name, 'Macabi')]"
                style="font-size: x-large"
                ><strong
                  >Macabi: {{ filterExams(examList, name, "Macabi").length }}/{{
                    loginService.limits[getDbName(name, "Macabi")]
                  }}</strong
                ></span
              >
              <span
                [ngClass]="
                  examList &&
                  filterExams(examList, name, 'Meuhedet').length >=
                    loginService.limits[getDbName(name, 'Meuhedet')]
                    ? 'error'
                    : ''
                "
                *ngIf="loginService.limits[getDbName(name, 'Meuhedet')]"
                style="font-size: x-large"
                ><strong
                  >Meuhedet: {{ filterExams(examList, name, "Meuhedet").length }}/{{
                    loginService.limits[getDbName(name, "Meuhedet")]
                  }}</strong
                ></span
              >
              <span
                [ngClass]="
                  examList &&
                  filterExams(examList, name, 'Clalit').length >=
                    loginService.limits[getDbName(name, 'Clalit')]
                    ? 'error'
                    : ''
                "
                *ngIf="loginService.limits[getDbName(name, 'Clalit')]"
                style="font-size: x-large"
                ><strong
                  >Clalit: {{ filterExams(examList, name, "Clalit").length }}/{{
                    loginService.limits[getDbName(name, "Clalit")]
                  }}</strong
                ></span
              >
            </div>
          </div>
          <div class="l-flex patient-item" *ngFor="let exam of filterExams(examList, name)">
            <button
              class="w100 patient-item-link"
              (click)="goPatient(exam.PID)"
              matTooltip="Click to View Patient History"
            >
              <div class="l-table h100">
                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Time: <strong>{{ exam.CreationTime | date : "dd/MM/yyyy h:mm a" }}</strong>
                </span>
                <span class="l-td-m patient-item-cell patient-id">
                  ID: <strong>{{ exam.ID }}</strong>
                </span>

                <span class="l-td-m patient-item-cell patient-id">
                  Name: {{ exam.First }} {{ exam.Last }}
                </span>

                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Type:
                  <strong
                    >{{ exam.ExamType }}
                    <span *ngIf="exam.Changed">({{ exam.ChangedExamTitle }})</span></strong
                  >
                </span>
              </div>
            </button>
            <a
              class="l-td-m patient-item-exit"
              [ngClass]="getLocked(exam)"
              (click)="goExam(exam)"
              [matTooltip]="getLocked(exam) === 'locked' ? 'Locked By: ' + exam.LockedBy : 'View Exam'"
            ></a>
          </div>
        </div> -->
      </div>
      <div>
        @if (examListLoading) {
          <div class="list-spinner-wrap" [class.is-leaving]="examListFading">
            <img
              src="../../assets/images/Wedges.svg"
              alt="Loading..."
              class="list-spinner-img"
            />
          </div>
        } @else {
          @if (!isReports && examList && examList.length) {
            <app-pagination-controls
              [total]="examTotal"
              [page]="examPage"
              [totalPages]="examTotalPages"
              (prev)="previousExamPage()"
              (next)="nextExamPage()"
            ></app-pagination-controls>
          }
          @if (examList && examList.length === 0) {
            <p style="padding: 2rem; text-align: center">
              {{ "GUI.Patients.empty.exams" | translate }}
            </p>
          }
          <div class="l-flex patient-item" *ngFor="let exam of examList">
            <button
              class="w100 patient-item-link"
              (click)="goPatient(exam.PID)"
              matTooltip="Click to View Patient History"
            >
              <div class="l-table h100">
                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Time:
                  <strong>{{
                    exam.CreationTime | date: "dd/MM/yyyy h:mm a"
                  }}</strong>
                </span>
                <span class="l-td-m patient-item-cell patient-id">
                  ID: <strong>{{ exam.ID }}</strong>
                </span>

                <span class="l-td-m patient-item-cell patient-id">
                  Name: {{ exam.First }} {{ exam.Last }}
                </span>

                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Type:
                  <strong
                    >{{ exam.ExamType }}
                    <span *ngIf="exam.Changed"
                      >({{ exam.ChangedExamTitle }})</span
                    >
                    <span *ngIf="!exam.Changed && exam.SubExamType">
                      - {{ getSubExamLabel(exam.SubExamType) }}</span
                    ></strong
                  >
                </span>
                <!-- Macabi codes and prices information -->
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="
                    exam.HMOExamCode &&
                    getMacabiCodesPricesString(exam).codesDisplay
                  "
                >
                  <strong>Codes:</strong>
                  {{ getMacabiCodesPricesString(exam).codesDisplay }}
                </span>
                <span
                  class="l-td-m patient-item-cell patient-name-first"
                  *ngIf="
                    exam.HMOExamCode &&
                    getMacabiCodesPricesString(exam).totalPrice
                  "
                >
                  <strong>Total:</strong>
                  {{ getMacabiCodesPricesString(exam).totalPrice }}
                </span>
              </div>
            </button>
            <a
              class="l-td-m patient-item-exit"
              [ngClass]="getLocked(exam)"
              (click)="goExam(exam)"
              [matTooltip]="
                getLocked(exam) === 'locked'
                  ? 'Locked By: ' + exam.LockedBy
                  : 'View Exam'
              "
            ></a>
          </div>
          @if (!isReports && examList && examList.length >= examPageSize && examTotalPages > 1) {
            <app-pagination-controls
              [total]="examTotal"
              [page]="examPage"
              [totalPages]="examTotalPages"
              (prev)="previousExamPage()"
              (next)="nextExamPage()"
            ></app-pagination-controls>
          }
        }
      </div>
      <div>
        <img
          *ngIf="xmlLoading"
          src="../../assets/images/Wedges.svg"
          style="
            z-index: 0;
            margin-left: auto;
            margin-right: auto;
            position: absolute;
            left: 0;
            right: 0;
            top: 40vh;
          "
        />
        <div class="l-flex patient-item" *ngFor="let xml of xmlList">
          <div class="l-table h100">
            <span class="l-td-m patient-item-cell">
              Exam Time:
              <strong>{{
                xml.CreationTime | date: "dd/MM/yyyy h:mm a"
              }}</strong>
            </span>
            <span class="l-td-m patient-item-cell patient-id">
              ID: <strong>{{ xml.ID }}</strong>
            </span>

            <span class="l-td-m patient-item-cell patient-id">
              Name: {{ xml.First }} {{ xml.Last }}
            </span>

            <span class="l-td-m patient-item-cell">
              Exam Type:
              <strong
                >{{ xml.ExamType }}
                <span *ngIf="xml.Changed"
                  >({{ xml.ChangedExamTitle }})</span
                ></strong
              >
            </span>
            <span class="l-td-m patient-item-cell">
              Xml File Name: <strong>{{ xml.xmlName }} </strong>
            </span>
          </div>
        </div>
      </div>
    </main>

    <!-- ========================== main sidebar (start) ========================== -->

    <aside class="l-sidebar l-flex l-column">
      <img
        class="off-mobile sidebar-logo"
        src="assets/icons/logo.svg"
        alt="Artisan Sonics"
      />

      <!-- user panel (start) -->
      <div class="userPanel">
        <i class="userPanel-icon icon-female"> </i>

        <div class="userPanel-userName">Patient Search</div>

        <div class="search-patient">
          <div class="search-patient-field">
            <div class="t-field l-flex t-twin-fieldset">
              <label>
                <input
                  type="radio"
                  name="idp"
                  [(ngModel)]="idp"
                  [value]="1"
                  class="custom-check customInput"
                  aria-labelledby="pregnancy_popup-sex"
                />
                <i class="customInput-display"></i>
                <span class="t-field-desc"> ID </span>
              </label>
              <label>
                <input
                  type="radio"
                  name="idp"
                  [value]="0"
                  class="custom-check customInput"
                  aria-labelledby="pregnancy_popup-sex"
                />
                <i class="customInput-display"></i>
                <span class="t-field-desc"> Passport </span>
              </label>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field idnumber"
              [ngClass]="invalidi"
              placeholder="ID Number"
              [(ngModel)]="id"
              (keyup)="invalidi = ''; trysearch()"
              pattern="[A-Za-z0–9\-]+"
            />
            <div class="t-validation-message">
              <span>Invalid ID Number</span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field"
              placeholder="First Name"
              [ngClass]="invalidf"
              [(ngModel)]="first"
              (keyup)="invalidf = ''; trysearch()"
            />
            <div class="t-validation-message">
              <span>Please fill in first name</span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field"
              placeholder="Last Name"
              [ngClass]="invalidl"
              [(ngModel)]="last"
              (keyup)="invalidl = ''; trysearch()"
            />
            <div class="t-validation-message">
              <span>Please fill in last name</span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="tel"
              class="search-patient-field"
              placeholder="Phone"
              [(ngModel)]="phone"
            />
            <div class="t-validation-message">
              <span>Invlid phone</span>
            </div>
          </div>

          <div class="l-flex l-flex-w t-fieldmargin search-btns">
            <div class="w100" *ngIf="loginService.showAWL()">
              <button
                class="search-btn"
                (click)="AWL(); isReports = false"
                matTooltip="Artisan Worklist"
              >
                TodayList
              </button>
            </div>
            <div class="w50">
              <button
                class="search-btn"
                [disabled]="isSearchButtonDisabled"
                (click)="search(true); isReports = false"
                matTooltip="Search Patient"
              >
                Search
              </button>
            </div>
            <div class="w50">
              <button
                class="search-btn"
                (click)="clear()"
                [ngClass]="
                  id.length > 0 ||
                  last.length > 0 ||
                  first.length > 0 ||
                  phone.length > 0
                    ? ''
                    : 'search-btn--clear'
                "
                matTooltip="Clear Search Fields"
              >
                Clear
              </button>
            </div>
            <div class="w100">
              <button
                class="search-btn search-btn--newPatient"
                (click)="addPatient(); isReports = false"
                matTooltip="Open New Patient"
              >
                New Patient
              </button>
            </div>
            <div class="w100">
              <button
                class="search-btn"
                matTooltip="Search Exams"
                (click)="openEsearch = true; isReports = false"
              >
                Search Exams
              </button>
            </div>
            <div
              class="w100"
              *ngIf="
                loginService.userType == 'secretary' ||
                loginService.userType == 'doctor'
              "
            >
              <button
                class="search-btn"
                matTooltip="Reports"
                (click)="openEsearch = true; isReports = true"
              >
                Reports
              </button>
            </div>
            <div class="w100" *ngIf="hasMacabiFillPermission()">
              <button
                class="search-btn"
                matTooltip="Maccabi Credit check (WITHOUT card)"
                (click)="getTZ()"
              >
                Maccabi W/O Card
              </button>
            </div>
            <div
              class="w100"
              *ngIf="loginService?.premissions?.['GastroLabReports']"
            >
              <button
                class="search-btn"
                matTooltip="Lab Results"
                [routerLink]="['/labresults']"
                [queryParams]="
                  unassignedLabReports > 0
                    ? { unassignedLabReports: unassignedLabReports }
                    : {}
                "
              >
                Lab Results
                <div
                  [matBadge]="unreadLabReports"
                  [matBadgeHidden]="unreadLabReports === 0"
                  matBadgeColor="warn"
                  matBadgePosition="above after"
                  aria-label="New Lab Results"
                ></div>
              </button>
            </div>
          </div>
        </div>

        <div class="search-help">
          Need help?
          <button class="open-help" (click)="openHelp()">Click Here</button>
        </div>
      </div>
      <!-- user panel (end) -->

      <!-- main nav (start) -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <!-- main nav (end) -->
      <app-docpanel></app-docpanel>
    </aside>

    <!-- ========================== main sidebar (end) ========================== -->

    <app-bottombar></app-bottombar>
  </div>
  <!-- end wrapper -->

  <!-- ===================================== POPUP : HELP (START) =============================================== -->

  <div class="t-popup popup-help" *ngIf="showhelp">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="showhelp = false"
        ></button>

        <h2>Help</h2>

        <section class="part-help">
          <h3>Search</h3>

          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking at its layout. The point of
          using Lorem Ipsum is that it has a more-or-less normal distribution of
          letters, as opposed to using 'Content here, content here', making it
          look like readable English. Many desktop publishing packages and web
          page editors now use Lorem Ipsum as their default model text, and a
          search for 'lorem ipsum' will uncover many web sites still in their
          infancy. Various versions have evolved over the years, sometimes by
          accident, sometimes on purpose (injected humour and the like).
        </section>
      </div>
    </div>
  </div>
  <div class="t-popup popup-help" *ngIf="carderror" style="display: inherit">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="carderror = null"
        ></button>

        <h2
          style="direction: rtl; margin-right: 3em"
          *ngIf="!hasMacabiFillPermission()"
        >
          מטופל עם ת.ז. {{ carderror }} לא נמצאה ברשימת המוזמנים להיום.
        </h2>
        <h2
          style="direction: rtl; margin-right: 3em"
          *ngIf="hasMacabiFillPermission()"
        >
          {{ carderror }}
        </h2>

        <section class="part-help">
          <h3 style="direction: rtl">נא לבדוק נכונות המספר ולנסות שוב</h3>
        </section>
      </div>
    </div>
  </div>

  <!-- <div class="t-popup popup-help" *ngIf="tocopy" style="display: inherit">
    
            <div class="t-popup-close"></div>
            
            <div class="t-popup-frame">
                <div class="t-popup-body">
    
                    <button class="t-btn-popup-close" aria-label="close popup" (click)="toreassign=null;AWL()"></button>
    
                    <h2>
                        Warning!
                    </h2>
    
                    <section class="part-help">
    
                        <h3>
                            This will remove {{toreassign.First + ' ' + toreassign.Last}} from {{loginService.getDocByUID(toreassign.UID)}} and make her a patient of {{loginService.getDocByUID(toreassign.nUID)}}.
                        </h3>
                        <button (click)="reassign()">OK</button>    
                        <button style="float:right" (click)="toreassign=null;AWL()">Cancel</button> 
                    </section>                 
                </div>
            </div>
        </div>--->

  <img
    *ngIf="macSearch"
    src="../../assets/images/Wedges.svg"
    style="
      z-index: 0;
      margin-left: auto;
      margin-right: auto;
      position: absolute;
      left: 0;
      right: 0;
      top: 40vh;
    "
  />

  <div *ngIf="showUsgConsentModal" class="print-history-popup">
    <div class="print-history-popup-body">
      <h2 class="popup-title">Consent Form</h2>
      <button
        (click)="showUsgConsentModal = false"
        class="print-history-popup-close"
        aria-label="close popup"
      ></button>
      <div>
        <div
          class="l-flex-c l-flex-w l-justify h50 placenta-row"
          style="margin-top: 1em"
        >
          <label class="t-label-top">
            <span>Consent Type</span>
            <select class="t-select t-field" [(ngModel)]="consentTypeModal">
              <option value="" disabled>Select Consent Type</option>
              <option *ngFor="let type of consentTypes" [value]="type.key">{{ type.label }}</option>
            </select>
          </label>
        </div>
        <div
          class="l-flex-c l-flex-w l-justify h50 placenta-row"
          style="margin-top: 1em"
          *ngIf="
            clinicPractitioners?.length > 1 &&
            !loginService.separatedClinic &&
            loginService.userType !== 'doctor'
          "
        >
          <label class="t-label-top">
            <span>Doctor</span>
            <select
              class="t-select t-field"
              [(ngModel)]="consentPractitionerObj"
              (ngModelChange)="onConsentPractitionerChange($event)"
            >
              <option [ngValue]="null"></option>
              <ng-container *ngFor="let option of clinicPractitioners">
                <option [ngValue]="option">
                  {{ option.Title }} {{ option.Name }}
                </option>
              </ng-container>
            </select>
          </label>
        </div>
        <div
          class="l-flex-c l-flex-w l-justify h50 placenta-row"
          style="margin-top: 1em"
          *ngIf="loginService.userType === 'doctor'"
        >
          <label class="t-label-top">
            <span>Doctor</span>
            <span
              class="t-field"
              style="
                display: inline-block;
                padding: 0.4em 0.6em;
                background: #f5f5f5;
                border-radius: 4px;
              "
            >
              {{ loginService.username }}
            </span>
          </label>
        </div>
        <div
          class="l-flex-c l-flex-w l-justify h50 placenta-row"
          style="margin-top: 1em"
          *ngIf="
            loginService.userType !== 'doctor' &&
            (clinicPractitioners?.length === 1 ||
              loginService.separatedClinic) &&
            clinicPractitioners?.length > 0
          "
        >
          <label class="t-label-top">
            <span>Doctor</span>
            <span
              class="t-field"
              style="
                display: inline-block;
                padding: 0.4em 0.6em;
                background: #f5f5f5;
                border-radius: 4px;
              "
            >
              {{ consentPractitionerObj?.Title }}
              {{ consentPractitionerObj?.Name }}
            </span>
          </label>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-around;
            margin-top: 1.5em;
          "
        >
          <button
            class="orange-btn"
            (click)="confirmUsgConsentModal()"
            [disabled]="!consentTypeModal"
          >
            Open Form
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-informconcent
    *ngIf="inform"
    (closed)="closCalForm($event)"
    [pat]="exServ.patServ.getPat()"
    [form]="concentForm"
  ></app-informconcent>

  <app-usg-consent-form
    *ngIf="showUsgConsent"
    (closed)="closeUsgConsent()"
    [pat]="exServ.patServ.getPat()"
    [form]="concentForm"
    [consentType]="exServ.consentType"
  ></app-usg-consent-form>

  <app-loginbox
    *ngIf="showLogin"
    (closed)="showLogin = false"
    (viewonly)="viewonly()"
    [search]="true"
    [isnew]="false"
  ></app-loginbox>
  <app-patdetails
    *ngIf="selectedPatient && !typeForm"
    [pat]="selectedPatient"
    [awl]="chosenAWL"
    [awlExam]="awlExamType"
    [awlTime]="awlTime"
    [awlLMP]="awlLMP"
    [awlComment]="awlComment"
    [openWAWL]="loginService.barcodeScan"
    (closed)="onClosed($event)"
    (showpay)="paymentNoCard()"
  ></app-patdetails>
  <app-payment
    *ngIf="showpayment"
    [tz]="showpayment"
    [idtype]="idcode"
    [awlid]="selectedPatient.AWLID"
    [exp]="expcode"
    (closed)="showpayment = null"
  ></app-payment>
  <app-searchbox
    *ngIf="openEsearch"
    (closed)="searchClosed($event)"
    (closeReports)="searchXml($event)"
    [isReports]="isReports"
    [reportstype]="reportName || 'AllReports'"
    [hmostype]="hmostype"
    [isUSG]="loginService.isUSG"
    [startdate]="fromd"
    [enddate]="tod"
    [examtype]="examMode"
    [exams]="examVals"
  ></app-searchbox>
  <app-commerror></app-commerror>
  <app-printopts
    *ngIf="showprint"
    (closed)="showprint = false"
    [showopts]="showprintopts"
    [stats]="true"
    [isReport]="true"
    [type]="reportName"
    [startdate]="fromd"
    [enddate]="tod"
    [hmostype]="hmostype"
  >
  </app-printopts>
  <app-send-questionnaire
    *ngIf="showSendQuestionnaire"
    [patient]="sendQuestionnairePatient"
    (closed)="showSendQuestionnaire = false; selectedPatient = null"
  ></app-send-questionnaire>
</div>
